<template lang="pug">
  v-layout.box-button-select-formatter(align-center column)
    v-flex
      v-btn.box-button(
        @click="SelectButton"
        :class="{'bg-color-active': activar, 'border-main': main, 'bg-color-disabled': disabledMisValesDisponibles}"
        :style="{'border': activar ? '#f2f2f2 !important' : ''}"
        )
        span(
        :style="{'color': activar ? '#ffffff' : (main ? '#0855C4' : '') }"
        ) {{textBottunProp}}
</template>

<script>
export default {
  props: [
    'textBottunProp',
    'activar',
    'main',
    'disabledMisValesDisponibles'
  ],
  data () {
    return {
      textButton: this.textBottunProp,
      activarAux: false
    }
  },
  methods: {
    SelectButton () {
      this.$emit('selectButton', this.textButton.toLowerCase())
      this.activarAux = true
    }
  },
  mounted () {
    this.activarAux = this.activar
  }
}
</script>

<style scoped>
.theme--light.v-btn:not(.v-btn--icon) {
  background-color: var(--white-color);
}

.box-button-select-formatter button.box-button.bg-color-active {
  background-color: var(--first-brand-color);
}

.box-button-select-formatter button.box-button.border-main {
  border: 1px solid var(--first-brand-color);
}

.box-button-select-formatter button.box-button.bg-color-disabled {
  background-color: #c4c4c4;
}

.box-button-select-formatter button.box-button.bg-color-disabled span {
  color: var(--white-color);
}

@media (min-width: 360px) {
  .box-button-select-formatter .box-button span {
    color: #535D66;
    font-size: 18px;
    text-transform: none !important;
  }

  .box-button-select-formatter .box-button {
    border: 1px #C4C4C4 solid;
    color: #ffffff;
    box-shadow: 0px 0px !important;
    border-radius: 2rem;
    margin: 0;
    height: 35px;
    width: 7.5em;
    background-color: #ffffff;
  }
}

@media (min-width: 390px) {
  .box-button-select-formatter .box-button {
    height: 35px;
    width: 8.3em;
  }

}

@media (min-width: 1024px) {
  .box-button-select-formatter .box-button span {
    color: #535D66;
    font-size: 14px;
  }

  .box-button-select-formatter .box-button {
    border: 1px #C4C4C4 solid;
    color: #ffffff;
    box-shadow: 0px 0px !important;
    border-radius: 2rem;
    margin: 0;
    height: 30px;
    width: 6.3em;
    background-color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/generic/ButtonSelect.vue